export { default } from "./yesNoConfirmation.inner";
